var _filter, _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#A855F7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#D946EF",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#EC4899",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "softGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 24,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10          A20 20 0 1 0 40 30          L48 48          L35 35          A15 15 0 1 1 20 15          Z",
    fill: "url(#brandGradient)",
    filter: "url(#softGlow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5 H25 M3 15 H28 M6 25 H31",
    stroke: "url(#brandGradient)",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.9
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 85,
    textAnchor: "middle",
    fontFamily: "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont",
    fontWeight: 700,
    fontSize: 18,
    letterSpacing: 1,
    fill: "white"
  }, "quiqi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea2bbf3033e5d3f84348b0981faaa567.svg";
export { ForwardRef as ReactComponent };